import script from "./TexturedBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./TexturedBackground.vue?vue&type=script&setup=true&lang=js"

import "./TexturedBackground.vue?vue&type=style&index=0&id=693deb7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-693deb7e"]])

export default __exports__